import {
  InMemoryHeader,
  InMemoryString,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function getHeaders(languages) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title:"headers.memberdependants.id",
      type: new InMemoryString("Id"),
      sortable: true,
      visible: true,
      searchable: true,
      isIdentifier: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.category",
      type: new InMemoryString("CategoryId"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    // new InMemoryHeader({
    //   title: "components.membersmanagementtable.view",
    //   type: new InMemoryString("Info", {
    //     getString: (item, type) => {
    //       if (item.Info === null || item.Info === undefined) {
    //         return 0;
    //       }
    //       return item.Info.length;
    //     },
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    //   allowVisibilityChange: true,
    // })
  ];
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.left_drawer_menu_items.title_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Title${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }



  for (const lang of languages) {
    headers.push(new InMemoryHeader({
      title: i18n.t(`views.welcomekit.image_{0}`, [lang.language.toUpperCase()]),
      type: new InMemoryString(`Image${lang.language.toUpperCase()}`, {
        getHtml: (item, type) => {
          if (item[`Image${lang.language.toUpperCase()}`] === null || item[`Image${lang.language.toUpperCase()}`] === undefined) {
            return "";
          }
          const str = item[`Image${lang.language.toUpperCase()}`]
          return `<i class="v-icon notranslate mdi theme--light ${
            str
          }"></i><span style="margin-left:5px">${str}</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }))
  }

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.portal_providers_info.detail_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Detail${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.portal_providers_info.description_details_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`DescriptionDetail${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.portal_providers_info.contact_information_details_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`ContactInformationDetail${lang.language.toUpperCase()}`, {
          getHtml: (item, type) => {
            let str =
              type.getString(item, type).length > 200
                ? type.getString(item, type).slice(0, 200) + "..."
                : type.getString(item, type);
            return (
              "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
              str +
              "</div>"
            );
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }


  return headers;
}
export default getHeaders;
